/** Détecte un document Word (enum fichier, contentType API ou MIME). */
export function isWordContent(contentType?: string | null, fileType?: string | null): boolean {
  if (fileType === 'WORD') {
    return true;
  }
  const ct = (contentType ?? '').toUpperCase();
  if (!ct) {
    return false;
  }
  return (
    ct.includes('APPLICATION_DOC') ||
    ct.includes('MSWORD') ||
    ct.includes('WORDPROCESSINGML')
  );
}

/** URL d’intégration Microsoft Office Online pour prévisualiser un fichier Word accessible en HTTPS. */
export function buildOfficeOnlineEmbedUrl(documentUrl: string): string {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(documentUrl)}`;
}
